
import Form from "./Form.vue";
import VendedorData from "./VendedorData";
import { mapGetters } from "vuex";

export default {
  name: "app-vendedor-create",
  data() {
    return {
      vendedor: new VendedorData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
